<template>
  <v-card width="400" style="overflow-x: hidden;">
    <v-toolbar flat height="60px" color="primary">
      <v-layout align-center>
        <v-toolbar-title class="white--text">{{ item.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small color="white" @click="onClose()">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-layout>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-row class="ma-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <img v-if="url != null || getThumb() != null" :src="url != null ? url : getThumb()" height="300" width="396" @click="onClick()"/>
          <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
          >
        </v-col>
        <v-col cols="12" class="pa-0" align="center">
          <textarea
            name='policy'
            rows="6"
            no-resize
            v-model="item.policy"
            placeholder="経営理念"
            :disabled="type == 'view'"
            @change="onChange"
            style="width:90%;"
            class="headline b-B-GREY"
          >
          </textarea>
        </v-col>
        <v-col cols="12" class="pa-0" align="center">
          <textarea
            name='goal'
            rows="6"
            v-model="item.target"
            placeholder="教育目標"
            :disabled="type == 'view'"
            @change="onChange"
            style="width:90%;"
            class="headline"
          >
          </textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: [ 'type', 'item', 'policyImageFile' ],
  data () {
    return {
      url: null,
      file: null
    }
  },
  watch: {
    item () {
      if (this.item.policyImage === null) {
        this.url = this.file = null
      }
      if (this.policyImageFile === null) {
        this.url = this.file = null
      }
    }
  },
  methods: {
    getThumb () {
      if (this.item.policyImage) {
        return this.item.policyImage.thumbnail
      }
      return null
    },
    onClick () {
      if (this.$route.path === '/setting') {
        this.$refs.image.click()
      }
    },
    onChange () {
      this.$emit('modified')
    },
    onClose () {
      if (this.type === 'view') {
        this.$emit('dismissed')
      } else {
        this.url = this.file = null
        this.$emit('imageReset')
      }
    },
    onFilePicked (e) {
      var vm = this
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const reader = new FileReader()
        reader.readAsDataURL(files[0])
        reader.addEventListener('load', () => {
          vm.url = reader.result
          vm.file = files[0]
          vm.$emit('change', { url: vm.url, file: vm.file })
        })
      }
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover;
}
</style>
